import useLocalization from '../hooks/useLocalization'

interface ACAServicesProps {
   HasBenAdmin: boolean
   className: string
}

export default function ACAServices({
   HasBenAdmin,
   className,
}: ACAServicesProps) {
   const host_url =
      process.env.REACT_APP_HOST_URL || 'https://quote.bamboohr.net'
   const { getString } = useLocalization(host_url)

   const ACASectionHeader = getString(
      'pdf.aca.sectionheader',
      'Additional Benefits Administration Services not included in this price quote:',
   )
   const ACAServicesLine = getString('pdf.aca.servicesline', 'ACA Services')

   const ACALinkText = getString('pdf.aca.linktext', 'Link to details')

   const ACALinkUrl = getString(
      'pdf.aca.linkurl',
      'https://www.bamboohr.com/partner-programs/aca-reporting',
   )

   if (HasBenAdmin) {
      return (
         <div className={className}>
            <b className='productHeader'>{ACASectionHeader}</b>
            <br />
            <table
               className='tableClass4'
               cellPadding='0'
               cellSpacing='0'
               style={{ marginTop: '1em' }}
            >
               <thead>
                  <tr>
                     <th colSpan={2} scope='colgroup'>
                        &nbsp;
                     </th>
                  </tr>
               </thead>
               <tfoot>
                  <tr>
                     <td colSpan={2}>&nbsp;</td>
                  </tr>
               </tfoot>
               <tbody>
                  <tr>
                     <td>{ACAServicesLine}</td>
                     <td>
                        <a href={ACALinkUrl}>{ACALinkText}</a>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      )
   } else return <></>
}
